import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-003f4c91"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "detail"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("关闭");

import { computed, watch, ref } from 'vue';
import { getRepostProdList } from '@/request';
import { getVexTableProps } from '@/config';
export default {
  name: 'WechatRepoetDetailModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    data: {
      type: [Object, null],
      default: null
    }
  },
  emits: ['update:modelValue'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const table = ref();
    const scroll = ref();
    watch(() => props.data, () => {
      var _table$value;

      (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
    });
    watch(() => visible.value, newVal => {
      if (!newVal) {
        var _scroll$value;

        (_scroll$value = scroll.value) === null || _scroll$value === void 0 ? void 0 : _scroll$value.setScrollTop(0);
        console.log(scroll.value);
      }
    }, {
      flush: 'post'
    });
    const tableOptions = getVexTableProps({
      columns: [{
        title: '药品名称',
        field: 'prodName',
        width: '150px',
        showOverflow: true
      }, {
        title: '生产厂家',
        field: 'manufacture',
        width: '200px',
        showOverflow: true
      }, {
        title: '规格',
        field: 'prodSpecification',
        width: '200px',
        showOverflow: true
      }, {
        title: '客户采购价',
        field: 'prodSumPrice',
        width: '150px',
        showOverflow: true
      }, {
        title: '包装单位',
        field: 'packageUnit',
        width: '150px',
        showOverflow: true
      }, {
        title: '是否是赠品',
        field: 'type',
        width: '150px',
        showOverflow: true
      }, {
        title: '商品来源',
        field: 'sourceText',
        width: '150px',
        showOverflow: true
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            var _props$data;

            getRepostProdList({
              page: page.currentPage,
              rows: page.pageSize,
              declarationNo: (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.declarationNo
            }).then(data => {
              data.rows.forEach(item => {
                item.type = item.prodType === 1 ? '商品' : item.prodType === 2 ? '赠品' : '其他';
                item.sourceText = item.prodSource === 1 ? '万药城' : '自建';
                item.purchaseprice = item.purchaseprice || '未定价';
              });
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_tab_pane = _resolveComponent("el-tab-pane");

      const _component_el_tabs = _resolveComponent("el-tabs");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "详情",
        width: "800px",
        onClose: _cache[2] || (_cache[2] = $event => _unref(visible) ? visible.value = false : null)
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
          height: "500px",
          style: {
            "padding": "10px"
          },
          ref_key: "scroll",
          ref: scroll
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form, {
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tabs, {
              "model-value": "first"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
                label: "客户信息",
                name: "first"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_row, {
                  gutter: 10
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: "客户名称"
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_input, {
                        "model-value": __props.data.custName,
                        readonly: ""
                      }, null, 8, ["model-value"])]),
                      _: 1
                    })]),
                    _: 1
                  }), _createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: "客户地址"
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_input, {
                        "model-value": __props.data.custAddress,
                        readonly: ""
                      }, null, 8, ["model-value"])]),
                      _: 1
                    })]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_row, {
                  gutter: 10
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: "联系人"
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_input, {
                        "model-value": __props.data.custLinkName,
                        readonly: ""
                      }, null, 8, ["model-value"])]),
                      _: 1
                    })]),
                    _: 1
                  }), _createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: "联系电话"
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_input, {
                        "model-value": __props.data.custLinkPhone,
                        readonly: ""
                      }, null, 8, ["model-value"])]),
                      _: 1
                    })]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_row, {
                  gutter: 10
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: "客户来源"
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_input, {
                        "model-value": __props.data.custSourceText,
                        readonly: ""
                      }, null, 8, ["model-value"])]),
                      _: 1
                    })]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_tabs, {
              "model-value": "first"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
                label: "发货方",
                name: "first"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_row, {
                  gutter: 10
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: "发货方名称"
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_input, {
                        "model-value": __props.data.companyName,
                        readonly: ""
                      }, null, 8, ["model-value"])]),
                      _: 1
                    })]),
                    _: 1
                  }), _createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: "联系人"
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_input, {
                        "model-value": __props.data.custLinkName,
                        readonly: ""
                      }, null, 8, ["model-value"])]),
                      _: 1
                    })]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_tabs, {
              "model-value": "first"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
                label: "商品清单",
                name: "first"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_vxe_grid, _mergeProps({
                  ref_key: "table",
                  ref: table
                }, _unref(tableOptions)), null, 16)])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_tabs, {
              "model-value": "first"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
                label: "单据信息",
                name: "first"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_row, {
                  gutter: 10
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: "单据编号"
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_input, {
                        "model-value": __props.data.declarationNo,
                        readonly: ""
                      }, null, 8, ["model-value"])]),
                      _: 1
                    })]),
                    _: 1
                  }), _createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: "创建时间"
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_input, {
                        "model-value": __props.data.createAt,
                        readonly: ""
                      }, null, 8, ["model-value"])]),
                      _: 1
                    })]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_row, {
                  gutter: 10
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: "备注"
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_input, {
                        "model-value": __props.data.remark,
                        readonly: ""
                      }, null, 8, ["model-value"])]),
                      _: 1
                    })]),
                    _: 1
                  }), _createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: "单据金额"
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_input, {
                        "model-value": __props.data.declarationPrice,
                        readonly: ""
                      }, null, 8, ["model-value"])]),
                      _: 1
                    })]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_row, {
                  gutter: 10
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: "状态"
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_input, {
                        "model-value": __props.data.state_text,
                        readonly: ""
                      }, null, 8, ["model-value"])]),
                      _: 1
                    })]),
                    _: 1
                  }), _createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: "开票员留言"
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_input, {
                        "model-value": __props.data.leaveWord,
                        readonly: ""
                      }, null, 8, ["model-value"])]),
                      _: 1
                    })]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_tabs, {
              "model-value": "first"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
                label: "业务员",
                name: "first"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_row, {
                  gutter: 10
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: "业务员"
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_input, {
                        "model-value": __props.data.linkMan,
                        readonly: ""
                      }, null, 8, ["model-value"])]),
                      _: 1
                    })]),
                    _: 1
                  }), _createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: "控销团队"
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_input, {
                        "model-value": __props.data.supplierName,
                        readonly: ""
                      }, null, 8, ["model-value"])]),
                      _: 1
                    })]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_row, {
                  gutter: 10
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: "所属分管"
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_input, {
                        "model-value": __props.data.managerLinkMan,
                        readonly: ""
                      }, null, 8, ["model-value"])]),
                      _: 1
                    })]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 512)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};